import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "hooks/useAuth";

const WithdrawGuard = ({ children }) => {
  const { user, isLoggedIn } = useAuth();

  if (isLoggedIn && user && user.canViewWithdraw === false) {
    return <Navigate to="/dashboard/default" replace />;
  }

  return children;
};

WithdrawGuard.propTypes = {
  children: PropTypes.node,
};

export default WithdrawGuard;
